export const numbersMatch = (num1: number | null, num2: number | null) => {
  if (num1 === null || num2 === null) return false;
  return num1 === num2;
};

export const stringIncludesIgnoreCase = (
  searchedString: string | undefined | null,
  substring: string | undefined | null
): boolean => {
  if (
    searchedString === null ||
    searchedString === undefined ||
    substring === null ||
    substring === undefined
  )
    return false;
  return searchedString.toLowerCase().includes(substring.toLowerCase());
};

export const stringIncludesIgnoreCaseIgnoreNullSubstring = (
  searchedString: string | undefined | null,
  substring: string | undefined | null
): boolean => {
  if (searchedString === null || searchedString === undefined) return false;
  if (substring === null || substring === undefined) return true;
  return searchedString.toLowerCase().includes(substring.toLowerCase());
};

// export const getNameFromObjectShape = (item: object): string => {
//   if (
//     item.hasOwnProperty("serial") &&
//     item.hasOwnProperty("macAddress") &&
//     item.hasOwnProperty("hardwareTypeId") &&
//     item.hasOwnProperty("dateReceived")
//   )
//     return "inventoryHardware";
//   if (
//     item.hasOwnProperty("softwareSold") &&
//     item.hasOwnProperty("softwareVersions") &&
//     item.hasOwnProperty("type") &&
//     item.hasOwnProperty("demos")
//   )
//     return "software";
//   if (
//     item.hasOwnProperty("versionNumber") &&
//     item.hasOwnProperty("changelog") &&
//     item.hasOwnProperty("size") &&
//     item.hasOwnProperty("softwareId") &&
//     item.hasOwnProperty("operatingSystemsId") &&
//     item.hasOwnProperty("userguideName") &&
//     item.hasOwnProperty("userguideLink") &&
//     item.hasOwnProperty("createdAt") &&
//     item.hasOwnProperty("updatedAt")
//   )
//     return "softwareVersion";
//   if (item.hasOwnProperty("companyName") && item.hasOwnProperty("id"))
//     return "company";
//   if (item.hasOwnProperty("type") && item.hasOwnProperty("id"))
//     return "software";
//   if (
//     item.hasOwnProperty("serial") &&
//     item.hasOwnProperty("companies") &&
//     item.hasOwnProperty("hardwareTypeId") &&
//     item.hasOwnProperty("lptSold")
//   )
//     return "hardware";
//   if (item.hasOwnProperty("osName") && item.hasOwnProperty("id"))
//     return "operatingSystem";
//   if (item.hasOwnProperty("typeName") && item.hasOwnProperty("id"))
//     return "hardwareType";
//   return "";
// };
